/* jshint browser: true */
import '../scss/aimms-web.scss'

if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = Array.prototype.forEach
}

import globalJs from './components/_global'
import Accordion from './components/_accordion'
import burgerNav from './components/_burger-nav'
import carousel from './components/_carousel'
import cssAnimations from './components/_css-animations'
import filter from './components/_filter'
import primaryNav from './components/_primary-nav'
import revealText from './components/_reveal-text'
import slideshow from './components/_slideshow'
import slider from './components/_slider'
import lightbox from './components/_lightbox'
import story from './components/_story'
import shareLinks from './components/_share'
import tileGrid from './components/_tile-grid'
import knowledgeHub from './components/_knowledge-hub'
import splashBg from './components/_splash-bg'
import showDemoForm from './components/_show-demo-form'
import siteSearch from './components/_site-search'
import smoothScrollLinks from './components/_smooth-scroll-links'
import scrollToSection from './components/_scroll-to-section'
import addUTMParams from './components/_addUTMParams'
import TabbedContent from './components/_tabbed-content'
import TabbedContentAccordion from './components/_tabbed-content-accordion'
import alertBanner from './components/_alert-banner'
import navPanels from './components/_nav-panels'
import addCustomPropsForCSP from './components/_add_custom_props_for_csp'
import Footer from './components/_footer'
import Expandable from './components/_expandable'

// import SubscribeForm from './components/_subscribe-form'
import './components/masthead-offsets'

import './components/_site-header'
import './components/_aimms-pardot-iframe'

//import headline from './components/_headline';

window.addEventListener('DOMContentLoaded', function () {
	globalJs.init()
	addUTMParams()
	alertBanner()
})

Footer()
// SubscribeForm()
primaryNav.init()
burgerNav.init()
slideshow.init()
slider.init()

revealText.init()
cssAnimations.init()

var accordions = document.querySelectorAll('.js-accordion')

if (accordions) {
	accordions.forEach((acc) => {
		var accordion = new Accordion()
		accordion.init(acc)
	})
}

var tabbedContentItems = document.querySelectorAll('.js-tabbed-content')
if (tabbedContentItems) {
	tabbedContentItems.forEach((tabbedContentRoot) => {
		var tabbedContent = new TabbedContent()
		tabbedContent.init(tabbedContentRoot)
	})
}

if (window.tabbedContentData) {
	window.tabbedContentData.forEach((tabbedContentInstance) => {
		var tabbedContentAccordion = new TabbedContentAccordion()
		tabbedContentAccordion.init(tabbedContentInstance)
	})
}

carousel.init()

filter.init()
// headline.init();
lightbox.init()

story.init()
shareLinks.init()

tileGrid.init()

knowledgeHub.init()

splashBg.init()

// this is specifically the demo form, which transfers input from the main window, into the nested iframe
showDemoForm.init()

smoothScrollLinks.init()

scrollToSection.init()

addCustomPropsForCSP()

// these are generic pardot forms which don't transfer values around
// showPardotForm.init();

siteSearch.init()

Expandable.init()

navPanels()

// pinNav() // will just run on its own, don't need to call it

WebFont.load({
	custom: {
		families: ['AvenirNextLTPro-Regular', 'AvenirNextLTPro-Bold'],
	},
	// fontactive: function(fontFamily){
	//     console.log(fontFamily, ' just loaded');
	// },
	active: function () {
		window.dispatchEvent(new CustomEvent('fontLoaded', { font: 'AvenirNextLTPro-Regular' }))
	},
})

// load the demo form if its ID exists in the url
window.addEventListener('DOMContentLoaded', () => {
	if (window.location.hash && window.location.hash.indexOf('demo-form') !== -1) {
		const demoButton = document.querySelector('#demo-form-button')
		if (demoButton) {
			demoButton.click()
		}
	}
})

// this gets called from the Cookie plugin in WP, so nowhere in this codebase. But it IS used.
window.aimmsCookieHandler = () => {
	const cookieLinkContainer = document.querySelector('#ccc-proxy')

	if (cookieLinkContainer && CookieControl && CookieControl) {
		const cookieLink = cookieLinkContainer.querySelector('a')
		cookieLink.addEventListener('click', function (e) {
			e.preventDefault()
			CookieControl.open()
		})
		cookieLinkContainer.classList.add('is-ready')
	}
}

tippy('[data-tippy-content]', {
	arrow: false,
	allowHTML: true,
	theme: 'aimms-simple',
	appendTo: 'parent',
})
